/**
 * Created by Анжелика on 11.09.2017.
 */
import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import PropTypes from "prop-types";
import * as LoginActions from "../actions/login";
import * as RegActions from '../actions/registration';
import Player from './Player';
import Form from "../components/Form";
import Registration from "./Registration";

class App extends Component {

    render() {
        const {signIn, isRegister, loginError, loginActions, regActions} = this.props;
        return (
            <div id="ott-player" className="container">
                {!signIn
                    ? <div className="login-scene">
                        <div className="fullscreen-bg">
                        </div>
                        {isRegister ? <Registration/> : <Form error={loginError} login={loginActions.login} switchToRegistration={regActions.switchToRegistration}/>}
                    </div>
                    : <Player/>
                }
            </div>
        )
    }
}

App.propTypes = {
    signIn: PropTypes.bool.isRequired,
    loginError: PropTypes.string
};

const mapStateToProps = state => {
    return {
        signIn: state.users.login.signIn,
        isRegister: state.users.registration.isRegister,
        loginError: state.users.login.error
    }
};

const mapDispatchToProps = dispatch => {
    return {
        loginActions: bindActionCreators(LoginActions, dispatch),
        regActions: bindActionCreators(RegActions, dispatch)
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App);






// WEBPACK FOOTER //
// ./src/containers/App.js